import "./index.css";

export function Loading({ label = "" }) {
  return (
    <div
      className="container d-flex flex-column justify-content-around align-items-center animate__animated animate__fadeIn"
      style={{ minHeight: "100vh" }}
    >
      <img
        src="/images/ccia-logo-01.png"
        alt="ccia-logo.png"
        style={{ height: "16vh" }}
      />

      <div className="d-flex flex-column align-items-center gap-2">
        <div className="spinner-border" />

        {label && <strong className="ms-2">{label}</strong>}
      </div>

      <div className="d-grid d-lg-flex align-items-center text-center">
        {`Copyright 2021-${new Date().getFullYear()} © `}
        <a
          href="https://www.cciahn.com"
          target="_blank"
          rel="noreferrer"
          className="ms-1 copyright"
        >
          <b>Cámara de Comercio e Industrias de Atlántida</b>
        </a>
      </div>
    </div>
  );
}
